class PartnerListRequestModel {

    constructor(params) {

        if (typeof params === 'undefined') {
            return;
        }

    }

}

export default PartnerListRequestModel;